/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

export let MDTimezones = function() {

	var mj_timezones = {
		'-12:00,0': 'Etc/GMT-12',
		'-11:00,0': 'Etc/GMT-11',
		'-10:00,0': 'US/Hawaii',
		'-09:00,1': 'US/Alaska',
		'-08:00,1': 'US/Pacific',
		'-07:00,0': 'US/Arizona',
		'-07:00,1': 'US/Mountain',
		'-06:00,0': 'Canada/Saskatchewan',
		'-06:00,1': 'US/Central',
		'-05:00,0': 'US/Indiana-Starke',
		'-05:00,1': 'US/Eastern',
		'-04:00,1': 'Canada/Atlantic',
		'-04:00,0': 'America/Caracas',
		'-03:30,1': 'Canada/Newfoundland',
		'-03:00,1': 'America/Godthab',
		'-03:00,0': 'America/Argentina/Buenos_Aires',
		'-02:00,1': 'Atlantic/South_Georgia',
		'-01:00,1': 'Atlantic/Azores',
		'-01:00,0': 'Atlantic/Cape_Verde',
		'00:00,0': 'Africa/Casablanca',
		'00:00,1': 'Europe/Dublin',
		'+01:00,1': 'Europe/Berlin',
		'+01:00,0': 'Africa/Algiers',
		'+02:00,1': 'Europe/Athens',
		'+02:00,0': 'Africa/Harare',
		'+03:00,1': 'Europe/Helsinki',
		'+03:00,0': 'Europe/Moscow',		// no DST since Mar/27, 2011
		// '+03:00,0': 'Asia/Kuwait',
		'+03:30,0': 'Asia/Tehran',
		'+04:00,0': 'Asia/Dubai',
		// '+04:00,1': 'Asia/Baku',			// no DST since 2015
		'+04:30,0': 'Asia/Kabul',
		'+05:00,1': 'Asia/Yekaterinburg',
		'+05:00,0': 'Asia/Karachi',
		'+05:30,0': 'Asia/Kolkata',
		'+05:45,0': 'Asia/Katmandu',
		'+06:00,0': 'Asia/Dhaka',
		'+06:00,1': 'Asia/Almaty',
		'+06:30,0': 'Asia/Rangoon',
		'+07:00,1': 'Asia/Krasnoyarsk',
		'+07:00,0': 'Asia/Bangkok',
		'+08:00,0': 'Asia/Hong_Kong',
		'+08:00,1': 'Australia/Perth',
		'+09:00,1': 'Asia/Yakutsk',
		'+09:00,0': 'Asia/Seoul',
		'+09:30,0': 'Australia/Darwin',
		'+09:30,1': 'Australia/Adelaide',
		'+10:00,0': 'Australia/Brisbane',
		'+10:00,1': 'Australia/Melbourne',
		'+11:00,0': 'Asia/Magadan',
		'+12:00,1': 'Pacific/Auckland',
		'+12:00,0': 'Pacific/Funafuti',
		'+13:00,0': 'Pacific/Tongatapu',
	};

	function xtr_timezone1( str ) {
		var tz_id_re = /^([+-]?)(\d{2}):(\d{2})$/,
			xtr = tz_id_re.exec(str),
			ofs;
		if( xtr===null ) {
			var tz_id_re2 = /^([+-]?)(\d{2})$/,
				xtr2 = tz_id_re2.exec(str);
			if( xtr2===null ) {
				return null;
			}
			ofs = parseInt(xtr2[2],10);
			if( xtr2[1]=='-' ) ofs = -ofs;
			return [ofs,0];

		}
		ofs = parseInt(xtr[2],10) + parseInt(xtr[3],10)/60.0;
		if( xtr[1]=='-' ) ofs = -ofs;
		return [ofs,0];
	}


	var mj_timezone_id = '00:00,0';
	var mj_timezone_name = mj_timezones[mj_timezone_id];


	function getTimeOffsetByTimezone(timezone, date) {
		const dateText = Intl.DateTimeFormat([], {timeZone: timezone, timeZoneName: "longOffset"}).format(date? new Date(date) : new Date());
		const timezoneString = dateText.split(" ")[1].slice(3) || '+0';
		const timezoneParts = timezoneString.split(':');
		let timezoneOffset_Hours = parseInt(timezoneParts[0],10);
		let timezoneOffset_Minutes = 0;
		if( timezoneParts.length>1 ) {
			timezoneOffset_Minutes = parseInt(timezoneParts[1],10);
			if( timezoneOffset_Hours<0 ) timezoneOffset_Minutes *= -1;
		}
		return [timezoneOffset_Hours,timezoneOffset_Minutes];
	}

	function detect() {
		return Intl.DateTimeFormat().resolvedOptions().timeZone;
	}

	function convertOffsetToTimezone(tz) {
		if((tz.includes('+') || tz.includes('-')) && tz.includes(':')) {
			// old format -> find name
			tz = ( tz in mj_timezones ) ? mj_timezones[tz] : null;
		}
		if( tz ) {
			try {
				new Date().toLocaleString('de-DE', { timeZone: tz });
			} catch(e) {
				tz = null;
			}
		}
		return tz;
	}

	function init( tz ) {
		mj_timezone_name = convertOffsetToTimezone(tz);
		if( !mj_timezone_name ) { // <- either null, empty string or other "falsy" value ..
			// auto detect
			mj_timezone_name = detect();
		}
		return mj_timezone_name;
	}


	//Date & Time helper functions
	function xpl_datetime( d ) {
		var l = d ? d.length : 0;
		if( l >= 19 ) {			// YYYY-MM-DD HH:mm:ss
			return [
				parseInt(d.substr(0,4),10)||0,
				parseInt(d.substr(5,2),10)||0,
				parseInt(d.substr(8,2),10)||0,
				parseInt(d.substr(11,2),10)||0,
				parseInt(d.substr(14,2),10)||0,
				parseInt(d.substr(17,2),10)||0,
			];
		} else if( l>=10 ) {	// YYYY-MM-DD
			return [
				parseInt(d.substr(0,4),10)||0,
				parseInt(d.substr(5,2),10)||0,
				parseInt(d.substr(8,2),10)||0,
				0,0,0,
			];
		} 				// -invalid-
		return [ 0,0,0, 0,0,0 ];
	}

	function mj_date_object_to_datetime_string( d, with_actual_offsets ) {
		let r =  d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2)+' '+('0'+d.getHours()).slice(-2)+':'+('0'+d.getMinutes()).slice(-2)+':'+('0'+d.getSeconds()).slice(-2);
		if( with_actual_offsets ) {
			var offs_hours = with_actual_offsets[0];
			var offs_minutes = with_actual_offsets[1];
			var offs_sign = offs_hours<0 ? '-' : '+';
			r += offs_sign+('0'+Math.abs(offs_hours)).slice(-2)+':'+('0'+offs_minutes).slice(-2);
		}
		return r;
	}

	function datetime_tzoned2utc( d, tz_spec ) {
		d = xpl_datetime( d );
		if( d[0]==0 ) return '';

		// implied tz is always in contrast to utc with dst in effect or not
		var tz_info = xtr_timezone1(tz_spec);
		var offs = tz_info[0],
			offs_hours = parseInt(offs,10),
			offs_minutes = (offs-offs_hours) * 60;
		return mj_date_object_to_datetime_string( new Date( d[0],d[1]-1,d[2], d[3]-offs_hours,d[4]-offs_minutes,d[5] ) );
	}

	function datetime_any2local( d, with_offsets ) {
		var l = d ? d.length : 0;
		if( l <= 19 ) {										// "YYYY-MM-DD HH:mm:ss" or even "YYYY-MM-DD"
			// just expect it as being specified in utc... and convert it to local time now ...
			return datetime_utc2local(d,with_offsets);
		}
		//      "YYYY-MM-DD HH:mm:ss.xxxxx+ZZ"
		//   or "YYYY-MM-DD HH:mm:ss.xxxxx"
		//   or "YYYY-MM-DD HH:mm:ss+ZZ"
		//   or "YYYY-MM-DD HH:mm:ss+ZZ:zz"
		//   or "YYYY-MM-DD HH:mm:ss-ZZ"
		//   or "YYYY-MM-DD HH:mm:ss-ZZ:zz"
		// e.g. "2015-11-08 11:49:26.76923+00"
		var t = d.substr(0,19);
		var r = d.substr(19);							// => ".76923+ZZ"
		if( r.length>1 && r[0]=='.' ) {
			r = r.substr(1);							// =>  "76923+ZZ"
			while( r.length>0 && !(r[0]=='-'||r[0]=='+') ) r = r.substr(1);
			// =>  "+ZZ"
		}
		if( r.length>1 && (r[0]=='+'||r[0]=='-') ) {
			var tz_spec = r;
			var d_utc = datetime_tzoned2utc(t,tz_spec);
			return datetime_utc2local(d_utc,with_offsets);
		}
		return datetime_utc2local(t,with_offsets);
	}



	function datetime_utc2local( d, with_offsets ) {
		d = xpl_datetime( d );
		if( d[0]==0 ) return '';
		const at_date = new Date(d[0],d[1]-1,d[2], d[3],d[4],d[5]);
		var actual_offs = getTimeOffsetByTimezone(mj_timezone_name,at_date);
		return mj_date_object_to_datetime_string( new Date( d[0],d[1]-1,d[2], d[3]+actual_offs[0],d[4]+actual_offs[1],d[5] ), with_offsets ? actual_offs : null );
	}


	function datetime_local2utc( d ) {
		d = xpl_datetime( d );
		if( d[0]==0 ) return '';
		const at_date = new Date(d[0],d[1]-1,d[2], d[3],d[4],d[5]);
		var actual_offs = getTimeOffsetByTimezone(mj_timezone_name,at_date);
		return mj_date_object_to_datetime_string( new Date( d[0],d[1]-1,d[2], d[3]-actual_offs[0],d[4]-actual_offs[1],d[5] ) );
	}


	return {

		init: init,
		detect: detect,
		convertOffsetToTimezone: convertOffsetToTimezone,
		getTimeOffsetByTimezone: getTimeOffsetByTimezone,

		getTimezones: function() {
			let tzs = Intl.supportedValuesOf('timeZone');
			// filter out some zones
			return tzs.filter( (tz) => !tz.startsWith('Etc/') );
		},
		getTimezoneName: function() {
			return mj_timezone_name;
		},

		xpl_datetime: xpl_datetime,

		mj_datetime_to_date_object: function(d) {
			return new Date( d[0],d[1]-1,d[2], d[3],d[4],d[5] );
		},
		mj_date_object_to_datetime_string: mj_date_object_to_datetime_string,

		datetime_any2local: datetime_any2local,
		datetime_utc2local: datetime_utc2local,
		datetime_local2utc: datetime_local2utc,
	};

}(); // function MDTimezones


